import React from 'react';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const spanStyle = {
  display: 'inline-block',
  cursor: 'pointer',
};

const FallbackImageToolTip = () => (
  <Tippy
    appendTo={ref => {
      return ref.parentNode;
    }}
    trigger="click"
    arrow="true"
    placement="right"
    content="If no media is returned from the specified source, the API can return the image from the URL as the fallback image."
  >
    <span style={spanStyle} onClick={e => e.preventDefault()}>
      <FontAwesomeIcon icon="question-circle" />
    </span>
  </Tippy>
);

export default FallbackImageToolTip;



// WEBPACK FOOTER //
// ./src/components/Sidebar/fallbackImageToolTip.js